(function () {
  'use strict';

  var PRODUCT_WIDGET_API = 'https://judge.me/api/v1/widgets/product_review';
  var SHOP_WIDGET_API = 'https://judge.me/api/v1/widgets/all_reviews_page';
  var REMOTE_PER_PAGE = 30;

  function qs(el, sel) {
    return el.querySelector(sel);
  }

  function text(el) {
    return (el || '').toString();
  }

  function stripHtml(html) {
    var d = document.createElement('div');
    d.innerHTML = html || '';
    return (d.textContent || d.innerText || '').trim();
  }

  function picUrl(p) {
    if (!p) return '';
    if (typeof p === 'string') return p;
    var u = p.urls || p;
    return u.huge || u.large || u.small || u.compact || u.original || u.hidden || p.url || '';
  }

  function applyDisplayRules(r, labels) {
    if (typeof window.ttlApplyReviewDisplay === 'function') {
      return window.ttlApplyReviewDisplay(r, labels);
    }
    if (r) r.verified = true;
    return r;
  }

  function normalize(r, labels) {
    if (!r) return null;
    var pics = [];
    var list = r.pictures || r.pictures_urls || r.picture_urls || r.media || [];
    var i;
    for (i = 0; i < list.length; i++) {
      var url = picUrl(list[i]);
      if (url) pics.push(url);
    }
    var reviewer = r.reviewer || {};
    var product = r.product || {};
    var body = r.body || r.content || r.body_html || '';
    var name =
      reviewer.name ||
      reviewer.display_name ||
      r.reviewer_name ||
      r.name ||
      '';
    return applyDisplayRules(
      {
        id: String(r.uuid || r.id || name + body.slice(0, 24)),
        rating: Number(r.rating) || 0,
        title: r.title || '',
        body: body,
        created_at: r.created_at || r.updated_at || '',
        name: name,
        verified: !!(r.verified_buyer || reviewer.verified_buyer),
        pictures: pics,
        has_photo: pics.length > 0 || !!r.has_published_pictures,
        product_title: r.product_title || r.product_name || product.title || product.name || '',
        product_handle: r.product_handle || product.handle || '',
        product_url: r.product_url || product.url || product.link || '',
        product_id: String(
          r.product_external_id || r.product_id || product.external_id || product.id || ''
        )
      },
      labels
    );
  }

  function collectFromPayload(payload, labels) {
    var out = [];
    if (!payload) return out;
    if (typeof payload === 'string') {
      try {
        payload = JSON.parse(payload);
      } catch (e) {
        return out;
      }
    }
    if (Array.isArray(payload)) return payload.map(function (item) { return normalize(item, labels); }).filter(Boolean);
    var keys = ['reviews', 'review', 'items', 'featured_reviews'];
    var k;
    for (k = 0; k < keys.length; k++) {
      if (Array.isArray(payload[keys[k]])) {
        return payload[keys[k]].map(function (item) { return normalize(item, labels); }).filter(Boolean);
      }
    }
    if (payload.widget && Array.isArray(payload.widget.reviews)) {
      return payload.widget.reviews.map(function (item) { return normalize(item, labels); }).filter(Boolean);
    }
    if (payload.photo_gallery && Array.isArray(payload.photo_gallery)) {
      return payload.photo_gallery.map(function (item) { return normalize(item, labels); }).filter(Boolean);
    }
    return out;
  }

  function emptyHist() {
    return { 1: 0, 2: 0, 3: 0, 4: 0, 5: 0 };
  }

  function parseHistogram(raw) {
    var h = emptyHist();
    var found = false;
    if (!raw) return null;
    if (Array.isArray(raw)) {
      raw.forEach(function (item, i) {
        if (item && typeof item === 'object') {
          var star = Math.round(Number(item.rating || item.star || item.stars));
          var count = Number(item.count || item.total || item.value) || 0;
          if (star >= 1 && star <= 5) {
            h[star] = count;
            found = true;
          }
        } else {
          var idx = i + 1;
          if (idx >= 1 && idx <= 5) {
            h[idx] = Number(item) || 0;
            found = true;
          }
        }
      });
      return found ? h : null;
    }
    if (typeof raw === 'object') {
      [1, 2, 3, 4, 5].forEach(function (star) {
        if (raw[star] != null || raw[String(star)] != null) {
          h[star] = Number(raw[star] != null ? raw[star] : raw[String(star)]) || 0;
          found = true;
        }
      });
      return found ? h : null;
    }
    return null;
  }

  function histFromReviews(list) {
    var h = emptyHist();
    (list || []).forEach(function (r) {
      var star = Math.round(Number(r.rating) || 0);
      if (star >= 1 && star <= 5) h[star] += 1;
    });
    return h;
  }

  function mergeHist(a, b) {
    var h = emptyHist();
    [1, 2, 3, 4, 5].forEach(function (star) {
      h[star] = Math.max((a && a[star]) || 0, (b && b[star]) || 0);
    });
    return h;
  }

  function pickHistogram(raw) {
    if (!raw) return null;
    return (
      parseHistogram(raw.histogram) ||
      parseHistogram(raw.rating_histogram) ||
      parseHistogram(raw.ratings) ||
      parseHistogram(raw.histogram_counts)
    );
  }

  function formatAvg(avg) {
    var n = Math.round((Number(avg) || 0) * 10) / 10;
    try {
      return n.toLocaleString(document.documentElement.lang || 'fr', {
        minimumFractionDigits: 1,
        maximumFractionDigits: 1
      });
    } catch (e) {
      return n.toFixed(1);
    }
  }

  function sortReviews(list, key) {
    return list.slice().sort(function (a, b) {
      if (key === 'recent') {
        return new Date(b.created_at) - new Date(a.created_at);
      }
      if (b.rating !== a.rating) return b.rating - a.rating;
      var ap = a.has_photo ? 1 : 0;
      var bp = b.has_photo ? 1 : 0;
      if (bp !== ap) return bp - ap;
      return new Date(b.created_at) - new Date(a.created_at);
    });
  }

  function starsHtml(rating) {
    var n = Math.round(Number(rating) || 0);
    var s = '';
    var i;
    for (i = 1; i <= 5; i++) {
      s += '<span class="ttl-jm-star' + (i <= n ? ' is-on' : '') + '">★</span>';
    }
    return '<span class="ttl-jm-stars" aria-hidden="true">' + s + '</span>';
  }

  function formatDate(iso) {
    if (!iso) return '';
    var d = new Date(iso);
    if (isNaN(d.getTime())) return '';
    try {
      return new Intl.DateTimeFormat(document.documentElement.lang || 'fr', {
        day: 'numeric',
        month: 'long',
        year: 'numeric'
      }).format(d);
    } catch (e) {
      return iso.slice(0, 10);
    }
  }

  var VERIFIED_ICON =
    '<svg class="ttl-jm-verified__icon" width="14" height="14" viewBox="0 0 14 14" fill="none" aria-hidden="true"><circle cx="7" cy="7" r="7" fill="currentColor"/><path d="M4.1 7.2 6.1 9.2 9.9 4.8" stroke="#fff" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round"/></svg>';

  function verifiedHtml(i18n) {
    return (
      '<span class="ttl-jm-verified">' +
      VERIFIED_ICON +
      escapeHtml(i18n.verified) +
      '</span>'
    );
  }

  function resolveProduct(r, fallback, rootUrl, productMap, labels) {
    var mapped = (productMap && r.product_id && productMap[r.product_id]) || null;
    var draft = {
      product_title: r.product_title || (mapped && mapped.title) || fallback.title || '',
      product_handle: r.product_handle || (mapped && mapped.handle) || '',
      product_url: r.product_url || (mapped && mapped.url) || ''
    };
    if (typeof window.ttlApplyReviewDisplay === 'function') {
      window.ttlApplyReviewDisplay(draft, labels);
    }
    var title = draft.product_title;
    var handle = draft.product_handle;
    var url = draft.product_url;
    if (!url && handle) {
      url = String(rootUrl || '/').replace(/\/$/, '') + '/products/' + handle;
    }
    if (!url && fallback.url) url = fallback.url;
    return { title: title, url: url };
  }

  function barCardHtml(r, i18n, fallback, rootUrl, productMap, withPhoto, labels) {
    var product = resolveProduct(r, fallback, rootUrl, productMap, labels);
    var payload = {
      pictures: withPhoto && r.pictures && r.pictures[0] ? r.pictures : [],
      name: r.name,
      verified: r.verified,
      body: stripHtml(r.body),
      rating: r.rating,
      product_title: product.title,
      product_url: product.url
    };
    if (typeof window.ttlRenderBarCard === 'function') {
      return window.ttlRenderBarCard(
        payload,
        i18n.verified,
        String(rootUrl || '/').replace(/\/$/, ''),
        { openPhotos: true }
      );
    }
    return photoCardHtml(r, i18n, fallback, rootUrl, productMap, labels);
  }

  var ARROW_PREV =
    '<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true"><path d="M10 3 5 8l5 5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>';
  var ARROW_NEXT =
    '<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true"><path d="M6 3l5 5-5 5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>';

  function carouselHtml(cards, prevLabel, nextLabel) {
    return (
      '<ttl-ba-reviews class="ttl-bar__scroller" data-ttl-bar data-source="manual">' +
      '<div class="ttl-bar__track" data-ttl-bar-track>' +
      cards +
      '</div>' +
      '<button type="button" class="ttl-bar__arrow ttl-bar__arrow--prev" data-ttl-bar-arrow="prev" aria-label="' +
      escapeHtml(prevLabel) +
      '" disabled>' +
      ARROW_PREV +
      '</button>' +
      '<button type="button" class="ttl-bar__arrow ttl-bar__arrow--next" data-ttl-bar-arrow="next" aria-label="' +
      escapeHtml(nextLabel) +
      '">' +
      ARROW_NEXT +
      '</button>' +
      '</ttl-ba-reviews>'
    );
  }

  function photoCardHtml(r, i18n, fallback, rootUrl, productMap, labels) {
    var src = r.pictures[0].replace(/"/g, '');
    var product = resolveProduct(r, fallback, rootUrl, productMap, labels);
    var verified = r.verified ? verifiedHtml(i18n) : '';
    var productHtml = '';
    if (product.title) {
      if (product.url) {
        productHtml =
          '<a class="ttl-jm-photo-card__product" href="' +
          escapeHtml(product.url) +
          '">' +
          escapeHtml(product.title) +
          ' <span aria-hidden="true">→</span></a>';
      } else {
        productHtml =
          '<span class="ttl-jm-photo-card__product">' +
          escapeHtml(product.title) +
          '</span>';
      }
    }
    return (
      '<article class="ttl-jm-photo-card">' +
      '<button type="button" class="ttl-jm-photo-card__media" data-ttl-jm-open="' +
      encodeURIComponent(r.pictures[0]) +
      '" aria-label="' +
      escapeHtml(r.name) +
      '"><img src="' +
      src +
      '" alt="" loading="lazy"></button>' +
      '<div class="ttl-jm-photo-card__body">' +
      '<p class="ttl-jm-photo-card__name">' +
      escapeHtml(r.name) +
      '</p>' +
      '<div class="ttl-jm-photo-card__row">' +
      starsHtml(r.rating) +
      verified +
      '</div>' +
      '<p class="ttl-jm-photo-card__text">' +
      escapeHtml(stripHtml(r.body)) +
      '</p>' +
      productHtml +
      '</div></article>'
    );
  }

  function cardHtml(r, i18n) {
    var verified = r.verified ? verifiedHtml(i18n) : '';
    var title = r.title
      ? '<h3 class="ttl-jm-card__title">' + escapeHtml(r.title) + '</h3>'
      : '';
    return (
      '<article class="ttl-jm-card">' +
      '<div class="ttl-jm-card__body">' +
      '<div class="ttl-jm-card__meta">' +
      '<span class="ttl-jm-card__name">' +
      escapeHtml(r.name) +
      '</span>' +
      verified +
      '<span class="ttl-jm-card__date">' +
      escapeHtml(formatDate(r.created_at)) +
      '</span></div>' +
      starsHtml(r.rating) +
      title +
      '<div class="ttl-jm-card__text">' +
      escapeHtml(stripHtml(r.body)) +
      '</div></div></article>'
    );
  }

  function escapeHtml(str) {
    return String(str || '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  function unique(list) {
    var seen = {};
    var out = [];
    var i;
    for (i = 0; i < list.length; i++) {
      if (!list[i] || seen[list[i].id]) continue;
      seen[list[i].id] = true;
      out.push(list[i]);
    }
    return out;
  }

  function fetchReviews(token, shop, productId, page, perPage, shopMode, photosOnly) {
    if (!token || !shop) {
      return Promise.resolve({ reviews: [], current_page: 1, total_pages: 0 });
    }
    var params = new URLSearchParams({
      shop_domain: shop,
      api_token: token,
      page: String(page || 1),
      per_page: String(perPage || REMOTE_PER_PAGE),
      json_request: 'true'
    });
    var endpoint = shopMode ? SHOP_WIDGET_API : PRODUCT_WIDGET_API;
    if (!shopMode && productId) params.set('external_id', String(productId));
    if (photosOnly) params.set('sort_by', 'with_pictures');
    return fetch(endpoint + '?' + params.toString())
      .then(function (res) {
        if (!res.ok) throw new Error('jm ' + res.status);
        return res.json();
      })
      .then(function (data) {
        return {
          reviews: collectFromPayload(data),
          histogram: pickHistogram(data) || pickHistogram(data.widget),
          current_page: data.current_page || page || 1,
          total_pages: data.total_pages || 1
        };
      });
  }

  class TtlJmReviews extends HTMLElement {
    connectedCallback() {
      if (this._ready) return;
      this._ready = true;
      this.mount = qs(this, '[data-ttl-jm-mount]');
      this.i18n = {
        write: this.getAttribute('data-i18n-write') || '',
        photos: this.getAttribute('data-i18n-photos') || '',
        more: this.getAttribute('data-i18n-more') || '',
        verified: this.getAttribute('data-i18n-verified') || '',
        verifiedBadge: this.getAttribute('data-i18n-verified-badge') || '',
        empty: this.getAttribute('data-i18n-empty') || '',
        count: this.getAttribute('data-i18n-count') || '',
        gallery: this.getAttribute('data-i18n-gallery') || '',
        prev: this.getAttribute('data-i18n-prev') || '',
        next: this.getAttribute('data-i18n-next') || '',
        sortBest: this.getAttribute('data-i18n-sort-best') || '',
        sortRecent: this.getAttribute('data-i18n-sort-recent') || '',
        sortLabel: this.getAttribute('data-i18n-sort-label') || ''
      };
      this.mode = this.getAttribute('data-mode') || 'product';
      this.shop = this.getAttribute('data-shop-domain') || '';
      this.token = this.getAttribute('data-token') || '';
      this.perPage = parseInt(this.getAttribute('data-per-page'), 10) || 10;
      this.productIds = (this.getAttribute('data-product-ids') || '')
        .split(',')
        .map(function (s) {
          return s.trim();
        })
        .filter(Boolean);
      this.photosOnly = false;
      this.sortKey = 'best';
      this.filterRating = 0;
      this.histogram = emptyHist();
      this.page = 1;
      this.all = [];
      this.shown = 0;
      this.remotePage = 0;
      this.remoteTotalPages = 1;
      this.remoteLoading = false;
      this.avgScore = parseFloat(this.getAttribute('data-avg')) || 0;
      this.totalCount = parseInt(this.getAttribute('data-count'), 10) || 0;

      this.fallbackProduct = {
        title: this.getAttribute('data-product-title') || '',
        url: this.getAttribute('data-product-url') || ''
      };
      this.rootUrl = this.getAttribute('data-root-url') || '/';
      this.productMap = {};
      this.reviewLabels =
        typeof window.ttlReviewLabelsFromRoot === 'function'
          ? window.ttlReviewLabelsFromRoot(this)
          : null;

      var bootEl = qs(this, '[data-ttl-jm-bootstrap]');
      var boot = { reviews: [], widget: null, all: null, products: [] };
      try {
        boot = JSON.parse(bootEl.textContent || '{}');
      } catch (e) {
        boot = { reviews: [], widget: null, all: null, products: [] };
      }

      (boot.products || []).forEach(function (p) {
        if (p && p.id != null) this.productMap[String(p.id)] = p;
      }, this);

      var widget = boot.widget || {};
      var allWidget = boot.all || {};
      var bootCount =
        Number(widget.number_of_reviews) ||
        Number(allWidget.number_of_reviews) ||
        Number(allWidget.total_reviews) ||
        0;
      var bootAvg = parseFloat(widget.average_rating || allWidget.average_rating || 0) || 0;
      if (bootCount > this.totalCount) this.totalCount = bootCount;
      if (bootAvg && !this.avgScore) this.avgScore = bootAvg;
      this.histogram = mergeHist(
        pickHistogram(widget) || emptyHist(),
        pickHistogram(allWidget) || emptyHist()
      );

      var labels = this.reviewLabels;
      this.all = sortReviews(
        unique(
          collectFromPayload(boot.reviews, labels)
            .concat(collectFromPayload(boot.widget, labels))
            .concat(collectFromPayload(boot.all, labels))
        ),
        this.sortKey
      );
      this.histogram = mergeHist(this.histogram, histFromReviews(this.all));
      this.render(true);

      this.loadRemotePage().then(
        function () {
          this.render(true);
        }.bind(this)
      );

      this.addEventListener('click', this.onClick.bind(this));
    }

    remoteIds() {
      if (this.mode === 'shop') return [null];
      return this.productIds.length ? this.productIds : [null];
    }

    hasMoreRemote() {
      return this.remotePage < this.remoteTotalPages;
    }

    hasMore() {
      return this.shown < this.filtered().length || this.hasMoreRemote();
    }

    loadRemotePage() {
      var self = this;
      if (!this.token || this.remoteLoading || !this.hasMoreRemote()) {
        return Promise.resolve();
      }
      this.remoteLoading = true;
      var page = this.remotePage + 1;
      var shopMode = this.mode === 'shop';
      return Promise.all(
        this.remoteIds().map(function (id) {
          return fetchReviews(
            self.token,
            self.shop,
            id,
            page,
            REMOTE_PER_PAGE,
            shopMode,
            self.photosOnly
          ).catch(function () {
            return { reviews: [], current_page: page, total_pages: self.remoteTotalPages };
          });
        })
      )
        .then(function (results) {
          var merged = self.all.slice();
          var maxPages = self.remoteTotalPages;
          results.forEach(function (r) {
            var batch = (r.reviews || []).map(function (item) {
              return normalize(item, self.reviewLabels);
            });
            merged = merged.concat(batch);
            if (r.total_pages > maxPages) maxPages = r.total_pages;
          });
          self.all = sortReviews(unique(merged), self.sortKey);
          results.forEach(function (r) {
            if (r.histogram) self.histogram = mergeHist(self.histogram, r.histogram);
          });
          self.histogram = mergeHist(self.histogram, histFromReviews(self.all));
          self.remotePage = page;
          self.remoteTotalPages = maxPages;
          if (self.all.length > self.totalCount) self.totalCount = self.all.length;
        })
        .finally(function () {
          self.remoteLoading = false;
        });
    }

    filtered() {
      var list = this.all;
      var rating = this.filterRating;
      if (rating) {
        list = list.filter(function (r) {
          return Math.round(Number(r.rating) || 0) === rating;
        });
      }
      if (this.photosOnly) {
        list = list.filter(function (r) {
          return r.has_photo;
        });
      }
      return sortReviews(list, this.sortKey);
    }

    render(reset) {
      if (!this.mount) return;
      if (reset) this.shown = Math.min(this.perPage, this.filtered().length);
      var list = this.filtered().slice(0, this.shown);
      var avg = this.avgScore || this.avgFromList();
      var count = this.totalCount || this.all.length;
      if (this.all.length > count) count = this.all.length;

      var photos = [];
      var texts = [];
      list.forEach(function (r) {
        if (r.has_photo && r.pictures[0]) photos.push(r);
        else texts.push(r);
      });

      var cards = '';
      if (list.length === 0) {
        cards = '<p class="ttl-jm-reviews__empty">' + escapeHtml(this.i18n.empty) + '</p>';
      } else {
        if (photos.length) {
          cards += carouselHtml(
            photos
              .map(
                function (r) {
                  return barCardHtml(
                    r,
                    this.i18n,
                    this.fallbackProduct,
                    this.rootUrl,
                    this.productMap,
                    true,
                    this.reviewLabels
                  );
                }.bind(this)
              )
              .join(''),
            this.i18n.prev,
            this.i18n.next
          );
        }
        if (texts.length) {
          cards +=
            '<div class="ttl-bar__text-grid">' +
            texts
              .map(
                function (r) {
                  return barCardHtml(
                    r,
                    this.i18n,
                    this.fallbackProduct,
                    this.rootUrl,
                    this.productMap,
                    false,
                    this.reviewLabels
                  );
                }.bind(this)
              )
              .join('') +
            '</div>';
        }
      }

      var more = this.hasMore()
        ? '<button type="button" class="ttl-jm-reviews__more" data-ttl-jm-more>' +
          escapeHtml(this.i18n.more) +
          '</button>'
        : '';

      var write =
        '<button type="button" class="ttl-jm-reviews__write" data-ttl-jm-write>' +
        escapeHtml(this.i18n.write) +
        '</button>';

      var sort =
        '<label class="ttl-jm-reviews__sort">' +
        '<span class="visually-hidden">' +
        escapeHtml(this.i18n.sortLabel) +
        '</span>' +
        '<select data-ttl-jm-sort>' +
        '<option value="best"' +
        (this.sortKey === 'best' ? ' selected' : '') +
        '>' +
        escapeHtml(this.i18n.sortBest) +
        '</option>' +
        '<option value="recent"' +
        (this.sortKey === 'recent' ? ' selected' : '') +
        '>' +
        escapeHtml(this.i18n.sortRecent) +
        '</option></select></label>';

      this.mount.innerHTML =
        '<div class="ttl-jm-summary">' +
        this.summaryCardHtml(avg, count) +
        '<div class="ttl-jm-summary__actions">' +
        write +
        sort +
        '</div></div>' +
        cards +
        more;
    }

    summaryCardHtml(avg, count) {
      var hist = mergeHist(this.histogram, histFromReviews(this.all));
      var max = 1;
      var star;
      for (star = 1; star <= 5; star++) {
        if (hist[star] > max) max = hist[star];
      }
      var bars = '';
      for (star = 5; star >= 1; star--) {
        var n = hist[star] || 0;
        var width = Math.round((n / max) * 100);
        var active = this.filterRating === star;
        bars +=
          '<button type="button" class="ttl-jm-bar' +
          (active ? ' is-active' : '') +
          '" data-ttl-jm-rating="' +
          star +
          '" aria-pressed="' +
          (active ? 'true' : 'false') +
          '"><span class="ttl-jm-bar__label">' +
          star +
          ' <span class="ttl-jm-bar__star" aria-hidden="true">★</span></span>' +
          '<span class="ttl-jm-bar__track" aria-hidden="true"><span class="ttl-jm-bar__fill" style="width:' +
          width +
          '%"></span></span>' +
          '<span class="ttl-jm-bar__count">' +
          n +
          '</span></button>';
      }
      var badgeLabel = this.i18n.verifiedBadge || this.i18n.verified;
      return (
        '<div class="ttl-jm-summary__card">' +
        '<div class="ttl-jm-summary__score">' +
        '<span class="ttl-jm-summary__avg">' +
        formatAvg(avg) +
        '</span>' +
        starsHtml(avg) +
        '<span class="ttl-jm-summary__count">(' +
        count +
        ' ' +
        escapeHtml(this.i18n.count) +
        ')</span>' +
        '<span class="ttl-jm-verified">' +
        VERIFIED_ICON +
        escapeHtml(badgeLabel) +
        '</span></div>' +
        '<div class="ttl-jm-summary__bars">' +
        bars +
        '</div></div>'
      );
    }

    avgFromList() {
      if (!this.all.length) return 0;
      var s = 0;
      this.all.forEach(function (r) {
        s += r.rating;
      });
      return s / this.all.length;
    }

    onClick(e) {
      var more = e.target.closest('[data-ttl-jm-more]');
      if (more) {
        var self = this;
        var nextShown = this.shown + this.perPage;
        if (nextShown <= this.filtered().length) {
          this.shown = Math.min(nextShown, this.filtered().length);
          this.render(false);
          return;
        }
        this.loadRemotePage().then(function () {
          self.shown = Math.min(nextShown, self.filtered().length);
          if (self.shown === 0) self.shown = Math.min(self.perPage, self.filtered().length);
          self.render(false);
        });
        return;
      }
      var bar = e.target.closest('[data-ttl-jm-rating]');
      if (bar) {
        var next = parseInt(bar.getAttribute('data-ttl-jm-rating'), 10) || 0;
        this.filterRating = this.filterRating === next ? 0 : next;
        this.render(true);
        return;
      }
      var write = e.target.closest('[data-ttl-jm-write]');
      if (write) {
        this.openWrite();
        return;
      }
      var photo = e.target.closest('[data-ttl-jm-open]');
      if (photo) {
        var url = decodeURIComponent(photo.getAttribute('data-ttl-jm-open') || '');
        if (url) window.open(url, '_blank', 'noopener');
        return;
      }
    }

    openWrite() {
      var native = document.querySelector(
        '.jdgm-write-rev-link, .jm-write-review, .jm-header-widget-btn, [class*="write-rev"]'
      );
      if (native) {
        native.click();
        return;
      }
      var id = this.productIds[0];
      if (id) {
        window.location.hash = 'judgeme_product_reviews';
      }
    }
  }

  if (!customElements.get('ttl-jm-reviews')) {
    customElements.define('ttl-jm-reviews', TtlJmReviews);
  }

  document.addEventListener('change', function (e) {
    var box = e.target.closest('[data-ttl-jm-photos]');
    if (box) {
      var photosRoot = box.closest('ttl-jm-reviews');
      if (!photosRoot) return;
      photosRoot.photosOnly = box.checked;
      photosRoot.render(true);
      return;
    }
    var sort = e.target.closest('[data-ttl-jm-sort]');
    if (!sort) return;
    var root = sort.closest('ttl-jm-reviews');
    if (!root) return;
    root.sortKey = sort.value === 'recent' ? 'recent' : 'best';
    root.render(true);
  });
})();
